<template>
  <div class="module_course page_content aggregated_dignostic_report " aria-label="Aggregated Dignostic Report Page">
        <course-header :course-id="course.uuid" class="header_course_dashboard"></course-header>

    <div class="row page_content_container">
      <div class="loader_container" v-if="!showPage">
        <stretch class="loader_v24"></stretch>
      </div>
      <div class="col-12 dasboard-left-section report-Page" v-if="itemsArray.length>0">
          <b-row>
            <b-col cols="12">
              <!-- Heading -->
              <b-row class="heading">
                <div class="col-7 hd_txt">
                  <span class="ace_sec_hd">Aggrgated Report :: Diagnostic Test <b>{{itemsArray[0].title}}</b></span>
                </div>

                <div class="col-5 hd_btn_container">
                  <input class="search_field" v-model="searchQuery" placeholder="search by name">
                  <b-btn class="btn ic_btn" @click="sort = 'sortD'" v-if="sort === 'sortA'">
                    <span class="ic22-sort"></span>
                  </b-btn>
                  <b-btn class="btn ic_btn" @click="sort = 'sortA'" v-if="sort === 'sortD'">
                    <span class="ic22-sort"></span>
                  </b-btn>
                  <b-btn @click="exportReport">export</b-btn>
                </div>

              </b-row>

              <!-- Report -->
              <div class="row">
                <div class="col-12 competency-details-row data_table_container">
                  <div class="table_h_scroll">
                    <table class="table report_table" border="0">
                      <thead>
                        <tr>
                          <th v-for="(col, index) in columns">
                            <div class="row">
                              <div class="col-12 col_title" :title="col.label" v-b-tooltip.hover>
                                {{ col.label }}
                              </div>
                            </div>
                            <div class="row score_status_row">
                              <div class="col-3 sec_txt_score">
                                score
                              </div>
                              <div class="col-3 performance_bx">
                                performance
                              </div>
                              <div class="col-5 status_txt">
                                status
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      <template v-for="reportItem in itemsToShow">
                        <tr>
                          <td>
                            <div class="usr_col">
                              <div class="ic_usr">
                                <span class="ic22-student1"></span>
                              </div>
                              <div class="user_name" :title="reportItem.displayName" v-b-tooltip.hover>
                                {{ reportItem.displayName }}
                              </div>
                            </div>
                          </td>
                          <td v-for="detail in reportItem.items">
                              <div class="row score_status_row" :class="setGradeScore(detail.performance)" :title="reportItem.displayName" v-b-tooltip.hover>
                                <div class="col-3 sec_txt_score">
                                  <span class="txt"> {{ detail.correctCount }}/{{ detail.questionCount }} </span>
                                  <span class="ic ic24-flower1"></span>
                                </div>
                                <div class="col-3" style="max-width: 100px;">
                                  <div class="performance_bx">
                                    {{detail.performance}}%
                                  </div>
                                </div>
                                <div class="col-6 status_txt">{{detail.status}}</div>
                              </div>
                          </td>

                        </tr>
                      </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
      </div>
      <div class="col-12 dasboard-left-section report-Page" v-else>
          <b-row>
            <b-col cols="12">
              <!-- Heading -->
              <b-row class="heading">
                <div class="col-7 hd_txt">
                  <span class="ace_sec_hd">Aggrgated Report :: Diagnostic Test </span>
                  <span>Not Available</span>
                </div>
              </b-row>
            </b-col>
          </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../assets/module/sass/reports/classReport.scss'
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import _ from 'lodash'
import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'aggregatedDignosticTestReport',
  props: ['uuid', 'assessmentId'],
  components: {
    CourseNav,
    CourseHeader,
    Stretch
  },

  data: () => {
    return {
      showPage: false,
      sort: 'sortA',
      selectedCourseIds: [],
      columns: [
        {
          id: 'name',
          label: 'Student Name'
        }

      ],
      userMap: {},
      itemsMap: {},
      itemsArray: [],
      observationsResponse: {},
      isAllSections: false,
      searchQuery: '',
      showObservation: false,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      competencyIds: {},
      kCStatusMap: {}
    }
  },

  watch: {
    sort (newSort) {
      this.itemsArray = this.sortArrayOfObjects(this.itemsArray, 'displayName', this.sort)
    }
  },

  mounted () {
    this.setupDignosticReportForClass()
  },

  methods: {
    ...mapActions([
      'loadCourseDetailFromServer',
      'exportDignosticReportToCsv',
      'loadChildrenCompetencySummaryForClass',
      'loadDignosticReportForClass',
      'exportObservationoToCsv',
    ]),
    async setupDignosticReportForClass() {

      if (this.uuid) {
        await this.loadCourseDetailFromServer(this.uuid)
      }
      this.itemsArray = []
      let itemsArray1 =  await this.loadDignosticReportForClass({courseId:this.uuid, assessmentId:this.assessmentId})
      let first = itemsArray1[0]
      if(first) {
        for(let firstItem of first.items){
            let otherColum = {'id':firstItem.competencyTitle, 'label':firstItem.competencyTitle}
            this.columns.push(otherColum)
        }
        for(let i=0; i<itemsArray1.length;i++){
            let i1 = itemsArray1[i]
            if(i1) {
              this.itemsArray.push(i1)
            }
        }
      }
      this.itemsArray = this.sortArrayOfObjects(this.itemsArray, 'displayName', this.sort)
      this.showPage = true

    },
    async exportReport () {
      let response = await this.exportDignosticReportToCsv({courseId: this.uuid, assessmentId: this.assessmentId})
      let summaryCsvFile = response && response.fileContents ? response.fileContents : response
      let errors = response && response.error ? response.error : ''
      let warnings = response && response.warning ? response.warning : ''
      if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
        return this.notifyFailure(errors)
      }
      this.writeFile(summaryCsvFile)
      if (warnings && warnings.length > 0) {
        this.notifyWarning(warnings)
      } else {
        this.notifySuccess('Aggregated Dignostic Report Successfully Exported to Csv')
      }
    },
    writeFile (data) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = 'Aggregated_Dignostic_Report.csv'
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },

    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyWarning (text) {
      this.$notify({
        group: 'notify',
        type: 'warn',
        title: '',
        text: text
      })
    },
    getItemObject(index, attribute){
        return this.itemsArray[index]?this.itemsArray[index][attribute]:''
    },
    setGradeScore (performanceVal) {
      if (performanceVal >= 90) {
        return 'gradeA'
      } else if (performanceVal >= 80 && performanceVal < 90) {
        return 'gradeB'
      } else if (performanceVal >= 65 && performanceVal < 80) {
        return 'gradeC'
      } else if (performanceVal >= 40 && performanceVal < 65) {
        return 'gradeD'
      } else if (performanceVal < 40) {
        return 'gradeE'
      }
    },
    sortArrayOfObjects (arr, propertyName, order) {
      if (order === 'sortA') {
        const sortedArr = arr.sort((a, b) => {
          if (a[propertyName] < b[propertyName]) {
            return -1
          }
          if (a[propertyName] > b[propertyName]) {
            return 1
          }
          return 0
        })
        return sortedArr
      }

      if (order === 'sortD') {
        const sortedArr = arr.sort((a, b) => {
          if (a[propertyName] > b[propertyName]) {
            return -1
          }
          if (a[propertyName] < b[propertyName]) {
            return 1
          }
          return 0
        })
        return sortedArr
      }

    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'fullClassSummary': state => state.course.fullClassSummary,
      'competencySummaryForClass': state => state.course.competencySummaryForClass,
      'childrenCompetencySummaryForClass': state => state.course.childrenCompetencySummaryForClass,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'userObj': state => state.user.userObj
    }),
    isSuperSupervisor () {
      if (this.userObj && this.userObj.customPermission && this.userObj.customPermission.superSupervisorRole) {
        return true
      }
      return false
    },
    itemsToShow () {
      return this.itemsArray.filter(item => {
        return item.displayName.toLowerCase().includes(this.searchQuery.toLowerCase())
      })
    }
  }

}
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/app/course/components/AggregatedDignosticTestReport.vue